import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetActiveTabs,
  setFamilyEmpDataActions,
  setFamilyEmpDatacreateActions,
  setFamilyEmpDataEditActions,
} from "../../../Redux/Slice";
import { Input } from "rsuite";
import { data } from "jquery";
import Select from "react-select";
import { toast } from "react-toastify";

const FamilyDetails = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const initialState = {
    phone_number: "",
    person_type: "",
    person_name: "",
    person_age: "",
    marital_status: "unmarried",
  };
  const [data, setDatas] = useState(initialState);
  const [phoneErr, setPhoneErr] = useState();
  const [NameErr, setNameErr] = useState();
  const [AgeErt, setAgeErr] = useState();

  const HandleChanges = (e) => {
    setDatas((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const [selectedValues, setSelectedValues] = useState([]);
  const [disabledDa, setDisables] = useState();
  const handleChange = (selectedOption) => {
    setSelectedValues(selectedOption || []);
  };

  const isOptionDisabled = (option) => {
    setDisables(option);
    // return selectedValues && selectedValues.some((selected) => selected.value === option.value);
  };

  useEffect(() => {
    if (
      state.FormsIDList.FamilyDetailsId != "" &&
      state.EmployeeProfile.EmployeeProfileList != "" &&
      state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
      state.EmployeeProfile.EmployeeProfileList.user_id != "" &&
      state.FormsIDList.ActiveTabs == 7
    ) {
      let payload = {
        Retieveid: state.FormsIDList.FamilyDetailsId,
        UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
      };
      dispatch(setFamilyEmpDataActions(payload));
    }
  }, []);
  useEffect(() => {
    if (
      state.FormsIDList.FamilyDetailsId == state.FamilyList.FamilyDetails.id &&
      state.FamilyList.FamilyDetails.id != undefined &&
      state.FormsIDList.FamilyDetailsId != ""
    ) {
      setDatas({
        ...data,
        phone_number: state.FamilyList.FamilyDetails.phone_number,
        person_name: state.FamilyList.FamilyDetails.person_name,
        person_age: state.FamilyList.FamilyDetails.person_age,
        person_type: state.FamilyList.FamilyDetails.person_type,
        marital_status: state.FamilyList.FamilyDetails.marital_status,
      });
    }
  }, [state.FamilyList.FamilyDetails]);
  useEffect(() => {
    if (state.FormsIDList.FamilyDetailsId != "") {
      setDisplay(true);
    }
  }, [state.FamilyList.FamilyDetailsI]);

  // useEffect(() => {
  // state.FamilyList.FamilyDetails.map((item) => {
  // console.log(item.person_name, "itemsxcS", [state.FamilyList.FamilyDetails]);
  // });
  // }, [state.FamilyList.FamilyDetails]);
  //
  //const [FamilyOptions, setFamilyOptions] = useState(Options);

  const [FamilyOptions, setFamliyOptions] = useState([
    { value: "father", label: "Father" },
    // { value: "mother", label: "Mother" },
    // { value: "spouse", label: "Spouse" },
    // { value: "son", label: "Son" },
    // { value: "daughter", label: "Daughter" },
    // { value: "guardian", label: "Guardian" },
  ]);

  const [selected, setSelectal] = useState();
  const Options = [
    {
      id: 1,
      value: "Father",
    },
    {
      id: 2,
      value: "Mother",
    },
    {
      id: 3,
      value: "Spouse",
    },
    {
      id: 4,
      value: "Son",
    },
    {
      id: 5,
      value: "Daughter",
    },

    {
      id: 6,
      value: "Guardian",
    },
  ];

  ///--Marriage---status---
  const Options1 = [
    {
      id: 1,
      value: "unmarried",
    },
    {
      id: 2,
      value: "married",
    },

    {
      id: 3,
      value: "widow",
    },
    {
      id: 4,
      value: "other",
    },
    {
      id: 5,
      value: "Divorced",
    },
  ];

  console.log(data, "datasasdcasidawd", FamilyOptions);
  useEffect(() => {
    if (data.marital_status) {
      if (data.marital_status == "unmarried") {
        setFamliyOptions([
          { value: "father", label: "Father" },
          { value: "mother", label: "Mother" },
          { value: "guardian", label: "Guardian" },
        ]);
      } else if (data.marital_status == "married") {
        setFamliyOptions([
          { value: "father", label: "Father" },
          { value: "mother", label: "Mother" },
          { value: "son", label: "Son" },
          { value: "daughter", label: "Daughter" },
        ]);
      } else if (data.marital_status == "widow") {
        setFamliyOptions([
          { value: "father", label: "Father" },
          { value: "mother", label: "Mother" },
          { value: "spouse", label: "Spouse" },
          { value: "son", label: "Son" },
          { value: "daughter", label: "Daughter" },
          { value: "guardian", label: "Guardian" },
        ]);
      } else if (data.marital_status == "other") {
        setFamliyOptions([
          { value: "father", label: "Father" },
          { value: "mother", label: "Mother" },
          { value: "spouse", label: "Spouse" },
          { value: "son", label: "Son" },
          { value: "daughter", label: "Daughter" },
          { value: "guardian", label: "Guardian" },
        ]);
      } else if (data.marital_status == "Divorced") {
        setFamliyOptions([
          { value: "father", label: "Father" },
          { value: "mother", label: "Mother" },
          { value: "spouse", label: "Spouse" },
          { value: "son", label: "Son" },
          { value: "daughter", label: "Daughter" },
          { value: "guardian", label: "Guardian" },
        ]);
      }
    }
  }, [data.marital_status]);

  const [selectedName, setSelectName] = useState();
  const [selectedEducation, setSelectedEducation] = useState([]);
  const [SelectOptions, setSelectedoptions] = useState([]);

  ////---The----Selected----Values-----
  const HandleAddingChanges = (e) => {
    setSelectName(e.value);
    // setFamliyOptions((prevOptions) =>
    //   prevOptions.filter((option) => option.value !== e.value)
    // );
    setSelectedoptions((prevState) => [...prevState, e]);

    // console.log(FamilyOptions ,"FamliyOptions", setFamliyOptions((prevOptions) =>
    // prevOptions.filter((option) => option.value !== e.value)));
    setSelectedEducation((prevState) => [...prevState, e]);
  };

  // Options.filter((element) => {
  //   if (element.value == selectedName) {
  //    // console.log(element.value, selectedName, "selectedNamezs");
  //   }
  // });

  // const [inputFields, setInputFields] = useState([
  //   {
  //     person_name: "",
  //     person_age: "",
  //     person_type: "",
  //     phone_number: "",
  //   },
  // ]);

  ///---Capital---word--
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  //   const uniqueData = state.FamilyList.FamilyDetails.filter((entry, index, self) =>
  //   index === self.findIndex((t) => (
  //     t.person_name === entry.person_name &&
  //     t.person_age === entry.person_age &&
  //     t.person_type === entry.person_type &&
  //     t.phone_number === entry.phone_number
  //   ))
  // );
  // console.log(uniqueData ,"uniqueData");

  useEffect(() => {
    var defaultFields = [];
    if (state.FormsIDList.FamilyDetailsId == "") {
      defaultFields = [
        // {
        // person_name: "",
        // person_age: "",
        // person_type: "",
        // phone_number: "",
        // family_id: "",
        // },
      ];
    }

    // If state.FamilyList.FamilyDetails exists, update inputFields
    if (
      state.FormsIDList.FamilyDetailsId !== "" &&
      state.FamilyList.FamilyDetails !== undefined &&
      state.FamilyList.FamilyDetails !== null
    ) {
      setInputFields(
        defaultFields.concat(
          state.FamilyList.FamilyDetails.map((item) => ({
            person_name: item.person_name,
            person_age: item.person_age,
            person_type: item.person_type,
            phone_number: item.phone_number,
            family_id: item.id,
          }))
        )
      );
      state.FamilyList.FamilyDetails.map((item) => {
        setFamliyOptions((prevOptions) =>
          prevOptions.filter((option) => option.value !== item.person_type)
        );
      });
    } else {
      setInputFields(defaultFields);
    }
  }, [state.FamilyList.FamilyDetails, state.FormsIDList.FamilyDetailsId]);

  const [inputFields, setInputFields] = useState(
    [
      // {
      //   person_name: "",
      //   person_age: "",
      //   person_type: "",
      //   phone_number: "",
      //   family_id: "",
      // },
    ]

    // // If PreviousEmpData exists, append its values to the defaultFields
    // if (
    //   state.FormsIDList.FamilyDetailsId != "" &&
    //   state.FamilyList.FamilyDetails !== undefined &&
    //   state.FamilyList.FamilyDetails != null
    // ) {
    //   return defaultFields.concat(
    //     state.FamilyList.FamilyDetails.map((item) => ({
    //       person_name: item.person_name,
    //       person_age: item.person_age,
    //       person_type: item.person_type,
    //       phone_number: item.phone_number,
    //       family_id:item.id
    //     }))
    //   );
    // }

    // return defaultFields;
  );

  const [types, setTypes] = useState();

  const handleAddFields = (e) => {
    //   console.log(e.value, "asdas");

    var values;
    if (e.value != null) {
      values = [...inputFields];
      values.push({
        person_name: "",
        person_age: "",
        person_type: e.value.toLowerCase(),
        phone_number: "",
        family_id: "",
      });

      setFamliyOptions((prevOptions) =>
        prevOptions.filter((option) => option.value !== e.value.toLowerCase())
      );
    }
    setInputFields(values);
  };

  // const handleRemoveFields = (index) => {
  //   const values = [...inputFields];
  //   console.log(values , "values", values.slice(0, index) , values.slice(index, 1));

  //  const test = values.slice(index, 1)
  //  console.log(test , "test");

  // //  console.log(test[1].person_type.toLowerCase() , "y8weofhweod");
  //   // values.splice(index, 1);

  // //  setInputFields(values);

  //   // setFamliyOptions((prevOptions) => [
  //   //   ...prevOptions,
  //   //   {
  //   //     value: test[1].person_type.toLowerCase(),
  //   //     label: capitalizeFirstLetter(test[1].person_type),
  //   //   },
  //   //   SelectOptions
  //   // ]);
  //   console.log(FamilyOptions, "FamilyOptions"  , SelectOptions);
  //   // setSelectName("")
  // };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    console.log(values, "values");

    // Get the element to be removed
    var removedElement = values[index];
    console.log(removedElement, "removedElement", removedElement.person_type);

    // Slice the array to remove the element
    const slicedValues = values.slice(0, index).concat(values.slice(index + 1));
    console.log(slicedValues, "slicedValues");
    setInputFields(slicedValues);

    setFamliyOptions((prevOptions) => [
      ...prevOptions,
      {
        value: removedElement.person_type,
        label: capitalizeFirstLetter(removedElement.person_type),
      },
      SelectOptions,
    ]);

    // Now you can perform any further operations with the removed element or the sliced array
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === "person_name") {
      values[index].person_name = event.target.value.toUpperCase();
    } else if (event.target.name === "person_age") {
      values[index].person_age = event.target.value.slice(0, 2);
    } else if (event.target.name === "phone_number") {
      values[index].phone_number = event.target.value.slice(0, 10);
    }
    setInputFields(values);
  };
  const [display, setDisplay] = useState(false);
  const [areMappedArraysEqual, setareMappedArraysEqual] = useState();

  useEffect(() => {
    const array1 = inputFields;
    const array2 = state.FamilyList.FamilyDetails;
    console.log(array2, array1, "array2");
    // Mapping the arrays
    const mappedArray1 = array1.map(
      (item) =>
        item.person_age &&
        item.person_name &&
        item.phone_number &&
        item.person_type
    );
    const mappedArray2 = array2.map(
      (item) =>
        item.person_age &&
        item.person_name &&
        item.phone_number &&
        item.person_type
    );

    // Function to check if two arrays are equal
    const arraysAreEqual = (arr1, arr2) => {
      // If the lengths are different, arrays can't be equal
      if (arr1.length !== arr2.length) {
        return false;
      }

      // Loop through each element and compare
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }

      // If all elements are equal, return true
      return true;
    };

    // Checking if mapped arrays are equal
    setareMappedArraysEqual(arraysAreEqual(mappedArray1, mappedArray2));
    console.log(arraysAreEqual(mappedArray1, mappedArray2), "mppaedsdwedk");
  }, [state.FamilyList.FamilyDetails, inputFields]);

  // const inputFields = [
  // selectedName == "Mother" && {
  // id: 1,
  // text: "Mother",
  // Label: "Name",
  // labelAG: "Age",
  // labelPh: "Phone Number",
  // important: "*",
  // InputName: (
  // <input
  // type="text"
  // class="form-control"
  // id="validationCustom01"
  // autocomplete="off"
  // name="person_name"
  // />
  // ),
  // age: (
  // <input
  // type="text"
  // class="form-control"
  // id="validationCustom01"
  // autocomplete="off"
  // name="person_name"
  // />
  // ),
  // phoneNumber: (
  // <input
  // type="text"
  // class="form-control"
  // id="validationCustom01"
  // autocomplete="off"
  // name="person_name"
  // />
  // ),
  // },
  //
  // {
  // id: 2,
  // text: "Father",
  // Label: "Name",
  // labelAG: "Age",
  // labelPh: "Phone Number",
  // important: "*",
  // InputName: (
  // <input
  // type="text"
  // class="form-control"
  // id="validationCustom01"
  // autocomplete="off"
  // name="person_name"
  // />
  // ),
  // age: (
  // <input
  // type="text"
  // class="form-control"
  // id="validationCustom01"
  // autocomplete="off"
  // name="person_name"
  // />
  // ),
  // phoneNumber: (
  // <input
  // type="text"
  // class="form-control"
  // id="validationCustom01"
  // autocomplete="off"
  // name="person_name"
  // />
  // ),
  // },
  // ];
  const HandleNext = () => {
    console.log(inputFields, "inputFields", areMappedArraysEqual);
    var a = 0;
    if (state.FormsIDList.FamilyDetailsId == "") {
      console.log("create");
      if (!display) {
        a = 1;
        toast.warning("Please select family  any Members.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      inputFields.map((item) => {
        if (item.person_age == "") {
          setAgeErr("*Age is required");
          a = 1;
        }
        if (item.person_name == "") {
          setNameErr("*Person Name is required");
          a = 1;
        }
        if (item.phone_number == "") {
          setPhoneErr("*Phone Number is required");
          a = 1;
        }
      });
      if (a == 0) {
        var datasend = {
          timeline_id: state.BasicFormCreated.BasciFormCreate,
          marital_status: data.marital_status,
          family_data: inputFields,
        };
        const payload = {
          data: datasend,
        };
        console.log(datasend, "data");
        dispatch(setFamilyEmpDatacreateActions(payload));
        //console.log(inputFields, "setPhoneErr");
      }
    } else if (
      state.FormsIDList.FamilyDetailsId != "" &&
      !areMappedArraysEqual
    ) {
      inputFields.map((item) => {
        if (item.person_age == "") {
          setAgeErr("*Age is required");
          a = 1;
        }
        if (item.person_name == "") {
          setNameErr("*Person Name is required");
          a = 1;
        }
        if (item.phone_number == "") {
          setPhoneErr("*Phone Number is required");
          a = 1;
        }
      });
      if (a == 0) {
        // console.log("edit");
        var datasend = {
          timeline_id: state.BasicFormCreated.BasciFormCreate,
          user_id: state.EmployeeProfile.EmployeeProfileList.user_id.id,
          marital_status: data.marital_status,
          family_data: inputFields,
        };
        const payload = {
          data: datasend,
          Retieveid: state.FormsIDList.FamilyDetailsId,
          UserId: state.EmployeeProfile.EmployeeProfileList.user_id.id,
        };

        dispatch(setFamilyEmpDataEditActions(payload));
      }
    } else if (areMappedArraysEqual) {
      dispatch(SetActiveTabs(8));
      // console.log("AnotherTab");
    }
  };
  return (
    <div className=" BodyContent">
      <div className="card">
        <div className="card-body cards ">
          <div className="UserPoup">
            <div className="BeforForms">
              <div className="Form">
                <div className="ModalHeader">
                  <div>
                    <span>Family Details</span>
                  </div>
                </div>
                <div className="row">
                  <>
                    <div
                      className="row"
                      style={{
                        padding: "0px 15px",
                        width: "100%",
                        paddingLeft: "40px",
                      }}
                    >
                      <div className="col-6  mt-3">
                        <select
                          style={{ width: "50%", padding: "10px" }}
                          //  class="form-select  col-8 form-select-lg "
                          // class="form-select"
                          class="form-select form-select-lg mb-3"
                          aria-label=".form-select-lg example"
                          //  className="form-select  col-7 "
                          name="marital_status"
                          //class="form-select " aria-label=".form-select example"
                          readOnly={
                            state.NumberCounts.Editable == 1 ? true : false
                          }
                          disabled={
                            state.NumberCounts.Editable == 1 ? true : false
                          }
                          onChange={(e) => {
                            HandleChanges(e);
                            //setMatriErr("");
                          }}
                        >
                          {/* {Options1.map((item) => (
                          <option
                            value={item.value}
                            selected={
                              data.marital_status.toLowerCase() ==
                              item.value.toLowerCase()
                            }
                          >
                            {item.value}
                          </option>
                        ))} */}

                          {/* {Options1 != undefined && Options1.filter(
                          (option) =>
                            !inputFields.some(
                              (field) =>
                              // field.person_type.toLowerCase() ===
                                option.value
                                //.toLowerCase()
                            )
                        ) */}
                          {Options1.map((item) => (
                            <option
                              key={item.value} // Make sure to provide a unique key for each option
                              value={item.value}
                              selected={
                                data.marital_status.toLowerCase() ===
                                item.value.toLowerCase()
                              }
                              disabled={
                                state.NumberCounts.Editable == 1 ? true : false
                              }
                            >
                              {item.value}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div
                        className="col-6 mt-3 AddingButton"
                        //style={{ padding: " 10px 30px" }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-end",
                        }}
                      >
                        <label className="form-label-Header">
                          {"categoies"}
                        </label>

                        {/* <div className="ADDBUTTON"> */}
                        {/* <select
                        //  className="form-select"
                        class="form-select form-select-lg"
                        style={{ padding: "2px" }}
                        //  aria-label=".form-select-lg example"
                        onChange={(e) => {
                          HandleAddingChanges(e);
                        }}
                        onClick={(e) => {
                          handleAddFields(e);
                          setDisplay(true);
                        }}
                      >
                        <>
                          <option selected disabled>
                            Add
                          </option>
                          {Options.map((item) => (
                            <option value={item.value}>{item.value}</option>
                          ))}
                        </>
                      </select> */}
                        <Select
                          options={
                            FamilyOptions != null
                              ? FamilyOptions
                              : { value: "Search", label: "Search" }
                          }
                          onChange={(e) => {
                            //handleChange(e)
                            HandleAddingChanges(e);
                            setSelectal(e);
                            handleAddFields(e);
                            setDisplay(true);
                          }}
                          isDisabled={
                            state.NumberCounts.Editable == 1 ? true : false
                          }
                        />
                      </div>
                    </div>
                  </>

                  {/* <>
                  {inputFields.map((item) => (
                    <div className="row" style={{ padding: "10px" }}>
                      <div className="col-12">
                        <h4 style={{ color: "#F05B38" }}>{item.text}</h4>
                      </div>
                      <div className="col-6 mt-3">
                        <label for="validationCustom01" class="form-label">
                          {item.Label}
                          <span style={{ color: "red" }}>{item.important}</span>
                        </label>
                        {item.InputName}
                      </div>

                      <div className="col-6 mt-3">
                        <label for="validationCustom01" class="form-label">
                          {item.labelAG}
                          <span style={{ color: "red" }}>{item.important}</span>
                        </label>
                        {item.age}
                      </div>

                      <div className="col-6 mt-3">
                        <label for="validationCustom01" class="form-label">
                          {item.labelPh}
                          <span style={{ color: "red" }}>{item.important}</span>
                        </label>
                        {item.phoneNumber}
                      </div>
                    </div>
                  ))}
                </> */}

                  {state.NumberCounts.Editable == 2 ? (
                    <div
                      className="form-row"
                      style={{
                        padding: "15px",
                        width: "100%",
                        paddingLeft: "40px",
                      }}
                    >
                      {display &&
                        inputFields.map((inputField, index) => (
                          <Fragment key={`${inputField}~${index}`}>
                            <div className="form-group col-sm-12 text-right">
                              {/* <button
                          // className="btn btn-link"
                          type="button"
                          disabled={index === 0}
                          onClick={() => handleRemoveFields(index)}
                          style={{
                            background: "#F05839",
                            color: "#fff",
                            fontWeight: "900",
                            borderRadius: "50% !important",
                          }}
                        ></button> */}

                              <div
                                className=" btn btn-link StatusList"
                                disabled={index === 0}
                                onClick={() => handleRemoveFields(index)}
                              >
                                <div className="DeclineStatus">
                                  <span>x</span>
                                </div>
                              </div>

                              {/* <buttou
                          className="btn btn-link"
                          type="button"
                          onClick={() => handleAddFields()}
                        >
                          +
                        </buttou> */}
                            </div>

                            <div className="col-12">
                              <h5>
                                {inputField.person_type != undefined &&
                                  capitalizeFirstLetter(inputField.person_type)}
                                {/* {inputField.person_type} */}
                              </h5>
                            </div>

                            <div className="form-group col-sm-6">
                              <label htmlFor="firstName">Person Name</label>
                              <input
                                type="text"
                                className="form-control"
                                id="firstName"
                                name="person_name"
                                value={inputField.person_name || ""}
                                onChange={(event) => {
                                  handleInputChange(index, event);
                                  setNameErr("");
                                }}
                                disabled={
                                  state.NumberCounts.Editable == 1
                                    ? true
                                    : false
                                }
                                autoComplete="off"
                              />
                              <p
                                className="Error"
                                style={{ paddingLeft: "12px" }}
                              >
                                {NameErr}
                              </p>
                            </div>

                            <div className="form-group col-sm-6">
                              <label htmlFor="firstName">Person Age</label>
                              <input
                                type="number"
                                className="form-control"
                                id="firstName"
                                name="person_age"
                                value={inputField.person_age}
                                onChange={(event) => {
                                  handleInputChange(index, event);
                                  setAgeErr("");
                                }}
                                autoComplete="off"
                                disabled={
                                  state.NumberCounts.Editable == 1
                                    ? true
                                    : false
                                }
                                maxLength={2}
                              />
                              <p
                                className="Error"
                                style={{ paddingLeft: "12px" }}
                              >
                                {AgeErt}
                              </p>
                            </div>

                            <div className="form-group col-sm-6">
                              <label htmlFor="firstName">
                                Person Phone Number
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                id="firstName"
                                onKeyDown={(evt) =>
                                  ["e", "E", "+", "-"].includes(evt.key) &&
                                  evt.preventDefault()
                                }
                                name="phone_number"
                                value={inputField.phone_number}
                                disabled={
                                  state.NumberCounts.Editable == 1
                                    ? true
                                    : false
                                }
                                onChange={(event) => {
                                  handleInputChange(index, event);
                                  setPhoneErr("");
                                }}
                                autoComplete="off"
                                maxLength={10}
                              />
                              <p
                                className="Error"
                                style={{ paddingLeft: "12px" }}
                              >
                                {phoneErr}
                              </p>
                            </div>
                          </Fragment>
                        ))}
                    </div>
                  ) : null}
                </div>

                {/* {state.NumberCounts.Editable == 2 ? (
                  <pre>{JSON.stringify(inputFields, null, 2)}</pre>
                ) : null} */}

                {
                  // state.FamilyList.FamilyDetailsId != undefined &&
                  //   state.FamilyList.FamilyDetails != undefined &&
                  // state.FamilyList.FamilyDetails[0]  != undefined &&
                  //   state.FormsIDList.FamilyDetailsId ==
                  //     state.FamilyList.FamilyDetails[0].id &&
                  state.FormsIDList.FamilyDetailsId != "" &&
                    state.NumberCounts.Editable == 1 &&
                    state.FamilyList.FamilyDetails.map((item) => {
                      return (
                        <div className="Modal_Body">
                          <div className="row" style={{ padding: "10px" }}>
                            <div
                              className="col-12"
                              style={{ marginTop: "30px" }}
                            >
                              <label className="form-label-Header">
                                {item.person_type.toUpperCase()}
                              </label>
                            </div>

                            <div className="col mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Name
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="person_name"
                                value={item.person_name}
                                readOnly={
                                  state.NumberCounts.Editable == 1
                                    ? true
                                    : false
                                }
                                disabled={
                                  state.NumberCounts.Editable == 1
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChanges(e);
                                }}
                              />
                            </div>

                            <div className="col mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Person age
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="person_age"
                                value={item.person_age}
                                readOnly={
                                  state.NumberCounts.Editable == 1
                                    ? true
                                    : false
                                }
                                disabled={
                                  state.NumberCounts.Editable == 1
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChanges(e);
                                }}
                              />
                            </div>
                          </div>
                          <div className="row" style={{ padding: "10px" }}>
                            <div className="col-6 mt-3">
                              <label
                                for="validationCustom01"
                                class="form-label"
                              >
                                Person phone number
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="validationCustom01"
                                autocomplete="off"
                                name="phone_number"
                                value={item.phone_number}
                                disabled={
                                  state.NumberCounts.Editable == 1
                                    ? true
                                    : false
                                }
                                readOnly={
                                  state.NumberCounts.Editable == 1
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  HandleChanges(e);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })
                }

                {state.NumberCounts.Editable == 2 ? (
                  <div
                    className="RoleButton"
                    style={{
                      display: "flex",
                      gap: "15px",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      padding: "0px 15px",
                      marginBottom: "20px",
                    }}
                  >
                    <button
                      class="btn CancelBtn"
                      style={{ color: "#ffff", background: "#234492" }}
                      onClick={(e) => {
                        dispatch(SetActiveTabs(6));
                      }}
                    >
                      Previous
                    </button>
                    <button
                      class="btn CancelBtn"
                      style={{ color: "#ffff", background: "#234492" }}
                      onClick={(e) => {
                        HandleNext(e);
                      }}
                    >
                      Next
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDetails;
